<template>
    <Message v-if="errorDetails.error" :headline="$t('uncaptured-error')" status="error">
        <h1 class="text-2xl font-bold">{{ errorDetails.error }}</h1>
        <p class="mb-1 text-red-800 text-xs">{{ $t('view-error-details-in-console') }}</p>
        <pre class="bg-gray-50 p-4 text-gray-700 whitespace-pre-line">{{ errorDetails }}</pre>
    </Message>

    <router-view />
</template>

<script setup lang="ts">
import Message from '@/components/Message/Message.vue';
import { config } from '@/config';
import { useHeadSafe } from '@unhead/vue';
import { onErrorCaptured, reactive } from 'vue';
import { getEnvironmentShort } from './utils/environment';
import { logErrorMessage } from './utils/errors';

const errorDetails = reactive<{
    error: Error | null;
    componentName: string;
    info: string | null;
}>({
    error: null,
    componentName: '(Not defined)',
    info: null,
});

onErrorCaptured((error, instance, info) => {
    errorDetails.error = error;
    // The instance should not be outputted in the template as this leads to infinite loops in the production build
    const instanceName = instance?.$.type.__name ?? '(Unknown)';
    errorDetails.componentName = instanceName;
    errorDetails.info = info;
    const errorMessage = `${error}, ${instanceName}, ${info}`;
    logErrorMessage(errorMessage);
    return false;
});

//<Seite> | space.cap [<Umgebung>]
const environment = getEnvironmentShort(config.envName);

const titleTemplate = config.showEnvName ? '%s %separator space.cap [%environment]' : '%s %separator space.cap';

useHeadSafe({
    templateParams: { environment, separator: '|' },
    titleTemplate,
});
</script>

<style>
body {
    margin: 0;
}
</style>
